loadjs.ready('js_default', function () {
    $(document).ready(function () {
        new _nav();
        var $body = $('body');

        $('.icon--scroll-link').click(function (e) {
            e.preventDefault;
            const firstContainer = $('.el-teaser').first();
            const nextContainer = firstContainer.next();
            if (nextContainer) {
                $("html, body").animate({
                    scrollTop: nextContainer.offset().top
                }, 1000);
            }

        });

        $('.htmleditor a').each(function () {
            var href = $(this).attr('href');
            if (href.startsWith('http') || href.startsWith('www')) {
                var svg = '<svg class="svg-item icon--link-extern " viewBox="0 0 100 100"><use xlink:href="#icon--link-extern" /></svg>';
                $(this)
                    .addClass('extern link')
                    .html(svg + $(this).text());
            } else if (href.startsWith('mailto')) {
                var svg = '<svg class="svg-item icon--mail " viewBox="0 0 100 100"><use xlink:href="#icon--mail" /></svg>';
                $(this)
                    .addClass('mail link')
                    .html(svg + $(this).text());
            } else {
                $(this).addClass('internal-link');
                $(this).prepend('<svg>...</svg>'); // SVG für internen Link einfügen
            }
        });

        $('.el-leader__more--info').click(function (e) {
            e.preventDefault();
            $(this).next().toggle();
        });

    });
});

